module.exports = __webpack_public_path__ + "img/Icono-final-2_cuadrado.369c6eaf.png";